import DefaultModal from 'components/Modal/DefaultModal';
import React from 'react';

import FilterClientScreen from '../FilterClientScreen';
import FilterClientBroadcastList from '../FilterClientBroadcastList';

const ModalFilterClients = ({
  isModalOpen,
  onModalToggle,
  setSelectedClient,
  account = false,
  isBroadcastList = false,
  selectCurrent = [],
  ...props
}) => {

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title={account ? 'Buscar contas' : 'Buscar contatos'}
      showCloseButton={false}
      modalContainerClasses="modal-lg"
      {...props}
    >
      {isBroadcastList === true ? (
        <FilterClientBroadcastList
          setSelectedClient={setSelectedClient}
          account={account}
          selectCurrent={selectCurrent}
        />
      ) : (
        <FilterClientScreen
          setSelectedClient={setSelectedClient}
          account={account}
        />
      )}
    </DefaultModal>
  );
};

export default ModalFilterClients;
